var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFootIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.51798 20H14.998C17.758 20 18.858 18.31 18.988 16.25L19.508 7.99C19.648 5.83 17.928 4 15.758 4C15.148 4 14.588 3.65 14.308 3.11L13.588 1.66C13.128 0.75 11.928 0 10.908 0H8.61798C7.58798 0 6.38798 0.75 5.92798 1.66L5.20798 3.11C4.92798 3.65 4.36798 4 3.75798 4C1.58798 4 -0.13202 5.83 0.00798004 7.99L0.52798 16.25C0.64798 18.31 1.75798 20 4.51798 20Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.75H8.25C7.84 6.75 7.5 6.41 7.5 6C7.5 5.59 7.84 5.25 8.25 5.25H11.25C11.66 5.25 12 5.59 12 6C12 6.41 11.66 6.75 11.25 6.75Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.755 16.1243C11.6217 16.1243 13.135 14.611 13.135 12.7443C13.135 10.8775 11.6217 9.36426 9.755 9.36426C7.88828 9.36426 6.375 10.8775 6.375 12.7443C6.375 14.611 7.88828 16.1243 9.755 16.1243Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFootIcon01);
export default __webpack_public_path__ + "static/media/chat-foot-icon-01.7b8fb576580335e2c1420c60455ffef6.svg";
export { ForwardRef as ReactComponent };